export const INTENDED_URL = 'INTENDED_URL';

export interface UserDetails {
  firstName: string | undefined;
  lastName: string | undefined;
  displayName: string | undefined;
  locale: string | undefined;
  timezone: string | undefined;
  description: string | undefined | null;
  id: number;
}

export interface UserSecurityDetails {
  email: string | null | undefined;
  gravatar: string | null | undefined;
}

export interface UserOrganisationDetails {
  name: string | undefined;
  id: number | undefined;
}

export interface BackendUserDetails {
  firstName?: string;
  lastName?: string;
  attributes:
    | {
        firstLogin?: number;
        locale: string | undefined;
        timezone: string | undefined;
      }
    | undefined;
  protectedUser: boolean;
  displayName: string;
  orgName: string;
  orgId: number;
  parentOrgName?: string | null;
  email: string;
  id: number;
  phoneNumber?: string;
  userGroupName: string;
  accessType: string;
  roles: Array<string>;
  uiSkinName?: string;
}

export interface UserAttribute {
  name?: string;
  value?: string;
  getName(): string;
  getValue(): string;
}
